module.exports = __webpack_public_path__ + "static/media/hire.88f8ff0a.svg";